export default __webpack_public_path__ + "static/media/Untitled design.b0e6a31f.jpg";